module.exports = __webpack_public_path__ + "7c343274df3add4d96ba8a7598f58dca.svg";